import { useTranslation } from "react-i18next";
import {Consts} from "../pages/consts";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";
import React from "react";

const RiskInfo = ({ showRisk, setShowRisk, drug }) => {
  const { t } = useTranslation();

  let combinedRisk =
    +drug?.ddgi?.combined_risk === -1
      ? t("not_available").toLowerCase()
      : (Math.round(+drug?.ddgi?.combined_risk * 100 * 100) / 100).toFixed(2) + "%";

  let baseLineRisk;
  let explanation;

  if(+drug?.ddgi?.baseline_risk === -1 && +drug?.ddgi?.combined_risk <= 0){
    baseLineRisk = t("no_risk");
  } else if(+drug?.ddgi?.baseline_risk > 0){
    baseLineRisk = (Math.round(+drug?.ddgi?.baseline_risk * 100 * 100) / 100).toFixed(2)  + "%";
    explanation = drug?.ddgi?.severity;
  } else if(+drug?.ddgi?.baseline_risk === -1 && +drug?.ddgi?.combined_risk > 0){
    explanation = drug?.ddgi?.severity;
    baseLineRisk = t("not_available").toLowerCase();
  }

  return (
    <div className="w3-modal" style={{ display: showRisk ? Consts.BLOCK : Consts.NONE }}>
      <div className="w3-modal-content w3-animate-zoom ddi-dgi-panel dialog-narrow">
        <header className="feedback-modal-header">
          <h2>{t("adverse_event_risks")}</h2>
          <FontAwesomeIcon
            icon={faXmark}
            className="modal-close"
            onClick={() => setShowRisk(false)}
          />
        </header>
        <div className="w3-row w3-margin-top">
          <label className="bold-label w3-margin">
            {t("adverse_event_risks")} {t("for")} {" "}
            {drug?.productName === Consts.NOT_SPECIFIED
              ? t(Consts.NOT_SPECIFIED)
              : drug?.productName} (
            {drug?.activeSubstance.replace("&&&", ", ")})
          </label>
          {showRisk ? (
            <>
              <>
                <label className="w3-half w3-padding-small">
                  {t("without_this_medicine")}:{" "}
                  {baseLineRisk}
                </label>
                <label className="w3-half w3-padding-small">
                  {t("with_this_medicine")}: {combinedRisk}
                </label>
              </>
              <label className="w3-padding-small w3-margin-top">
                 {explanation}
              </label>
            </>
          ) : (
            <label className="w3-padding-small">
              {t("ddgis_check_not_possible")}
            </label>
          )}
        </div>
      </div>
    </div>
  );
};

export default RiskInfo;
